import React from "react";
import Text from "../../../Components/Text";
import DrowDown1 from "../../../Components/DropDown/DropDown1";
import Menu1 from "../../../config/HeaderConstants/Menus";
import { Courses } from "../../../config/HeaderConstants";
import { WidgetsRounded } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import classNames from "classnames";

type Props = {};

const HeaderBottomSection1 = (props: Props) => {
  const location = useLocation();
  return (
    <div
      className={classNames(
        location.pathname === "/" ? "bg-transparent" : "bg-[#DCE6FE]",
        "flex py-[15px] desktop:!py-[10px] 3xl:px-10 gap-[31px] font-semibold px-[85px]"
      )}
    >
      {Courses.map(({ title }: { title: string }) => {
        return (
          <DrowDown1
            title={
              <Text
                className={classNames(
                  location.pathname === "/" ? "text-white" : "text-black",
                  "3xl:text-[14px] desktop:!text-[10px] "
                )}
              >
                {title}
              </Text>
            }
            isDark={location.pathname !== "/"}
            menu={<Menu1 />}
          />
        );
      })}
      <div className="ml-auto">
        <DrowDown1
          title={
            <Text
              className={classNames(
                location.pathname === "/" ? "text-white" : "text-black",
                "flex 3xl:text-[14px] desktop:!text-[10px] items-center gap-1"
              )}
            >
              <WidgetsRounded className="!rotate-90 scale-110" />
              Explore More
            </Text>
          }
          isDark={location.pathname !== "/"}
          menu={<Menu1 />}
        />
      </div>
    </div>
  );
};

export default HeaderBottomSection1;
